import { IconLabelMolecule, TooltipMolecule } from "..";
import { IconAtom, InputAtom } from "../../atoms";
import styles from "./styles.module.scss";

interface Props {
  weblocatieTooltip?: string | string[];
  urlValue: string;
  urlError?: string;
  selectedFileName?: string;
  disabled?: boolean;
  inputRef?: (ref: HTMLInputElement) => void;
  onChange: (v: string) => void;
  onBlur: () => void;
  onClear: () => void;
  onHerindexatie?: () => void;
}

export function WeblocatieInvoerMolecule({
  weblocatieTooltip,
  urlValue,
  urlError,
  selectedFileName,
  disabled,
  inputRef,
  onChange,
  onBlur,
  onClear,
  onHerindexatie,
}: Readonly<Props>) {
  const urlDisabled = !!selectedFileName || !!disabled;
  const classnameWrapper = `${styles.url_input_wrapper} ${onHerindexatie ? styles.extra_padding : ""}`;
  return (
    <>
      <div className={styles.section_label_row}>
        <label className={styles.section_label} htmlFor={"weblocatie_input"}>
          Voer een link in
        </label>
        {weblocatieTooltip && <TooltipMolecule id={"weblocatie_label_tooltip"} content={weblocatieTooltip} />}
      </div>
      <div className={classnameWrapper}>
        <InputAtom
          id={"weblocatie_input"}
          type={"text"}
          value={urlValue}
          placeholder={"https://voorbeeld.nl/document.pdf"}
          disabled={urlDisabled}
          inputRef={inputRef}
          onChange={onChange}
          onBlur={onBlur}
          error={!!urlError}
        />
        {urlValue && !urlDisabled && (
          <div className={styles.url_actie_buttons}>
            <button
              id={"button-wissen"}
              className={styles.url_clear_button}
              type={"button"}
              title={"Wissen"}
              aria-label={"Link wissen"}
              onClick={onClear}
            >
              <IconAtom icon={"icon-cross-blue"} size={"small"} alt={"verwijder"} />
            </button>
            {onHerindexatie && (
              <button
                id={"button-herindexeren"}
                className={styles.url_herindexeren_button}
                type={"button"}
                title={"Herindexeren"}
                aria-label={"Link herindexeren"}
                onClick={onHerindexatie}
              >
                <IconAtom icon={"Opnieuw-blue"} size={"medium"} alt={"Herindexeren"} />
              </button>
            )}
          </div>
        )}
      </div>
      {!!selectedFileName && !disabled && (
        <IconLabelMolecule
          icon={"icon-alert-blue"}
          label={"Verwijder eerst het document om een link in te voeren"}
          type={"default"}
        />
      )}
      {urlError && <IconLabelMolecule icon={"icon-alert-red"} label={urlError} type={"alert"} />}
    </>
  );
}
